import { Fragment } from 'react';
import { format } from 'date-fns';

import Spacing from 'components/spacing/Spacing';

import MyStatistics from 'assets/single-event/my-statistics/my_statistics_bg.png';

import styles from '../../SingleEvent.module.scss';
import { ISingleEventMyStatistics } from '../../types';
import { PrizePoolItem } from '../PrizePoolSection/PrizePoolSection';
import { MyStatisticsItem } from './MyStatisticsItem';
import { MyStatisticsItemSeparator } from './MyStatisticsItemSeparator';

type MyStatisticsSectionProps = {
  myStatistics: ISingleEventMyStatistics;
  showEstimatedRewards?: boolean;
  showSeparator?: boolean;
};

const MyStatisticsSection = ({
  myStatistics,
  showEstimatedRewards = false,
  showSeparator = true,
}: MyStatisticsSectionProps) => {
  const lastUpdatedText = format(myStatistics.lastUpdated * 1000, 'yyyy/MM/dd HH:mm');
  const hasStatistics = myStatistics.statistics.length > 0;
  const hasEstimatedRewards = showEstimatedRewards && myStatistics.estimatedReward.length > 0;

  if (!hasStatistics && !hasEstimatedRewards) {
    return null;
  }

  return (
    <>
      <Spacing mobileHeight={60} />
      <div className="tw-mx-auto tw-max-w-[1280px] tw-px-[20px] lg:tw-px-0">
        <h2 className={styles.sectionHeader}>My Statistics</h2>
        <div
          className="tw-mt-[24px] tw-rounded-[16px] tw-bg-cover tw-bg-center tw-bg-no-repeat tw-px-[16px] tw-py-[20px] lg:tw-px-[24px] lg:tw-py-[32px]"
          style={{ backgroundImage: `url(${MyStatistics})` }}
        >
          {showEstimatedRewards && (
            <div className="tw-rounded-[16px] tw-bg-backgroundColorDark tw-p-[20px] lg:tw-p-[12px]">
              <p className="tw-text-[18px] tw-font-semibold tw-text-menuLinkColor">My Total Estimated Reward</p>

              <div className="tw-mt-[12px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[16px] tw-rounded-[14px] lg:tw-flex-row lg:tw-gap-[32px]">
                {myStatistics.estimatedReward.map((item) => {
                  const isLastItem = item === myStatistics.estimatedReward[myStatistics.estimatedReward.length - 1];
                  return (
                    <div key={item.name}>
                      <PrizePoolItem image={item.image} name={item.name} />
                      {!isLastItem && <div className="tw-h-[1px] tw-w-full tw-bg-[#3090DC] lg:tw-hidden" />}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {hasStatistics && (
            <div
              className={`${
                showEstimatedRewards ? 'tw-mt-[32px]' : ''
              } tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[14px] lg:tw-flex-row lg:tw-gap-[40px]`}
            >
              {myStatistics.statistics.map((stat, index) => (
                <Fragment key={stat.name}>
                  <MyStatisticsItem name={stat.name} value={stat.value} />
                  {index < myStatistics.statistics.length - 1 && <MyStatisticsItemSeparator />}
                </Fragment>
              ))}
              <MyStatisticsItemSeparator />
              <MyStatisticsItem name="Date last updated" value={lastUpdatedText} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MyStatisticsSection;
